import SafeLink from "modules/components/SafeLink";
import { ChevronRight } from "lucide-react";
import styles from "./yearCards.module.scss";

interface IProps {
  url: string;
  title: string;
}

function YearCards(props: IProps) {
  const { title, url } = props;
  return (
    <div>
      <SafeLink href={url}>
        <div className={styles.style_model_item}>
          <span>{title}</span>
          <ChevronRight style={{ fontSize: "calc(1 * var(--safari-root-font, 10px))", color: "#616161" }} />
        </div>
      </SafeLink>
    </div>

  );
}

export default YearCards;
